import { t } from 'i18next';
import * as yup from 'yup';

import { SystemRoles } from '~constants/enums';
import { M2MClient } from '~hooks/useApiClients/models';
import { RoleItem } from '~hooks/useUsers/models';

export const ALLOWED_M2M_ROLE_NAMES = new Set<string>([
  SystemRoles.COMPANY_ADMIN,
  SystemRoles.DATA_IMPORTER,
]);

// Mirrors the slug format the API enforces on M2M clients.
const SLUG_FORMAT = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

export const apiClientSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
  slug: yup
    .string()
    .trim()
    .matches(SLUG_FORMAT, {
      excludeEmptyString: true,
      message: t('form_validation_errors.invalid_slug_format'),
    })
    .defined(),
  roles: yup
    .array()
    .of(yup.mixed<RoleItem>().required())
    .min(1, t('form_validation_errors.required_simple'))
    .required(t('form_validation_errors.required_simple')),
});

export type ApiClientDto = yup.InferType<typeof apiClientSchema>;

export const setApiClientSchemaDefaultValues = (
  apiClient?: M2MClient,
  availableRoles: RoleItem[] = [],
): ApiClientDto => ({
  name: apiClient?.name ?? '',
  slug: apiClient?.slug ?? '',
  roles: apiClient
    ? availableRoles.filter((role) =>
        apiClient.iamRoles.some((assigned) => assigned.id === role.id),
      )
    : [],
});
